import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import * as LayoutComponents from '../Shared/LayoutComponents.js'
import CommentsList from '../Shared/CommentsList/CommentsList.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";
import '../Shared/Style.css';
import Attachments from "../Shared/Attachments.js";
import { useDropzone } from 'react-dropzone';
import MultiSelectField from "../Shared/MultiSelectField.js"
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";
import "./App.css";

import $ from "jquery";

import "trumbowyg/dist/ui/trumbowyg.min.css";



const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;
    const [isSavingItem, setIsSavingItem] = useState(false);
    const [isShowingSaveMessage, setIsShowingSaveMessage] = useState(false);
    const [visibleDetailsTab, setVisibleDetailsTab] = useState("information");
    const [autoCallOverviewFunction, setAutoCallOverviewFunction] = useState(false);
    const [itemDetailsPaneActive, setItemDetailsPaneActive] = useState(AppContext.isPaneOpen);
    const [itemDetailsPaneOpenEffect, setItemDetailsPaneOpenEffect] = useState(false);
    const [componentKey, setComponentKey] = useState(0);
    const [showItemContextMenu, setShowItemContextMenu] = useState(false);
    const [selectedPDFTab, setSelectedPDFTab] = useState("main");
    const [requestingTranslation, setRequestingTranslation] = useState(false);
    const [requestedTranslation, setRequestedTranslation] = useState(false);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false);
    const [isDeletingFile, setIsDeletingFile] = useState(false);
    const [currentLegalManufacturer, setCurrentLegalManufacturer] = useState("");
    const [selectedPDFVersion, setSelectedPDFVersion] = useState(null);
    const [isVersionDropdownOpen, setIsVersionDropdownOpen] = React.useState(false);
    const [productFamilies, setProductFamilies] = useState([]);
    const [countries, setCountries] = useState([]);
    const [legalManufacturers, setLegalManufacturers] = useState([]);
    const [physicalManufacturers, setPhysicalManufacturers] = useState([]);
    const [sppp, setSPPP] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isChangingArchiveStatus, setIsChangingArchiveStatus] = useState(false);
    const [version, setVersion] = useState(0);
    const [documentListRefresh, setDocumentListRefresh] = useState(0);
    const [isEditModeNote, setIsEditModeNote] = useState(false);

    const [isEditingField, setIsEditingField] = useState({
        SKUProductCode: false,
        ProductName: false,
        FamilyName: false,
    });

    const [errorCurrentItem, setErrorCurrentItem] = useState(false);

    const [isSavingItemNotes, setIsSavingItemNotes] = useState(false);
    const [isSavingItemContacts, setIsSavingItemContacts] = useState(false);
    const [isSavingItemIdentifiers, setIsSavingItemIdentifiers] = useState(false);
    const [isSavingItemEdit, setIsSavingItemEdit] = useState(false);
    const [isSavingItemAssignPriorityAlerts, setIsSavingItemAssignPriorityAlerts] = useState(false);
    const [isSavingItemCertificateSettings, setIsSavingItemCertificateSettings] = useState(false);


    const [isShowingSaveMessageNotes, setIsShowingSaveMessageNotes] = useState(false);
    const [isShowingSaveMessageContacts, setIsShowingSaveMessageContacts] = useState(false);
    const [isShowingSaveMessageIdentifiers, setIsShowingSaveMessageIdentifiers] = useState(false);
    const [isShowingSaveMessageEdit, setIsShowingSaveMessageEdit] = useState(false);
    const [isShowingSaveMessageAssignPriorityAlerts, setIsShowingSaveMessageAssignPriorityAlerts] = useState(false);
    const [isShowingSaveMessageCertificateSettings, setIsShowingSaveMessageCertificateSettings] = useState(false);

    const [isShowingDocumentAddPopup, setIsShowingDocumentAddPopup] = useState(false);

    const [localCurrentItem, setLocalCurrentItem] = useState({ AssignedTo: -1 });


    const contextMenuButton = useRef(null);
    const contextMenu = useRef(null);
    const versionsMenuButton = useRef(null);
    const versionsMenuOptions = useRef(null);
    const currentItemSKUProductCodeRef = useRef(null);
    const currentItemProductNameRef = useRef(null);



    const openDocumentPopup = () => {
        setIsShowingDocumentAddPopup(true);
    }

    const closeDocumentPopup = () => {
        setIsShowingDocumentAddPopup(false);
    }

    const successDocumentUploaded = () => {
        setDocumentListRefresh(prev => prev + 1);
    }




    
    const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

    const hasValue = (val) => {
        return val !== "" && val !== null;
    }
        
        

    function stringifyIfObject(value) {
        if (typeof value === "object" && value !== null) {
            return JSON.stringify(value);
        }
            return value;
    }



    const validFormField = (title, field) => {

        if (field == "SKUProductCode") {
            if (isNullOrEmpty(AppContext.currentItem[field])) {
                setErrorCurrentItem(title + " is a mandatory field"); return false;
            }
        }

        if (field == "ProductName") {
            if (isNullOrEmpty(AppContext.currentItem[field])) {
                setErrorCurrentItem(title + " is a mandatory field"); return false;
            }
        }



        return true;

    }


    const saveCurrentItem = () => {
        // Validations


        let isValidForm = true;

        setErrorCurrentItem(false);

        //if (!validFormField("Product Code", "SKUProductCode")) isValidForm = false;
        //if (!validFormField("Product Name", "ProductName")) isValidForm = false;

        const item = AppContext && AppContext.currentItem;

        if (item) {
            if (item.USANumberFEI && item.USANumberFEI.length > 10) isValidForm = false;
            if (item.EUNumberSRN && item.EUNumberSRN.length > 15) isValidForm = false;
            if (item.NumberDUNS && item.NumberDUNS.length > 9) isValidForm = false;
        }

        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();
        AppContext.currentItem.AssignedTo = localContext.currentItem.AssignedTo;
        // Update item remotely and if successful...

        let currentItem = JSON.parse(JSON.stringify(AppContext.currentItem));

        currentItem.Entities = AppContext.linkedObjectsList;

        currentItem.Note = AppContext.originalItem.Note; // Editing the note is a partial update, can't go here


        let updateItemURL = AppContext.dataUrl;

        let requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(currentItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);


                    // Update current item
                    AppContext.setCurrentItem(result);

                    // Update local original item to use when cancelling edit
                    AppContext.setOriginalItem(result);

                    setIsShowingSaveMessage(true);

                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItem(false);
            });
    };






    
    const saveCurrentItemPartial = (part) => {
        // Validations


        let isValidForm = true;

        setErrorCurrentItem(false);


        if (!isValidForm) return false;

        setIsSavingItem(true);
        setIsShowingSaveMessage(false);
        AppContext.disableAllItemFormFieldsEdit();


        setIsShowingSaveMessageNotes(false);
        setIsShowingSaveMessageContacts(false);
        setIsShowingSaveMessageIdentifiers(false);
        setIsShowingSaveMessageEdit(false);
        setIsShowingSaveMessageAssignPriorityAlerts(false);
        setIsShowingSaveMessageCertificateSettings(false);
        
        
        
        
        const updatedItem = structuredClone(AppContext.currentItem);


        let updateItemURL = "";
        let method = "PATCH";

        if (part == "notes") { 
            updateItemURL = "/umbraco/api/RIMSRegistrations/OperatorNotes/"; 
            setIsSavingItemNotes(true);
        }
        if (part == "contacts") { 
            updateItemURL = "/umbraco/api/RIMSRegistrations/OperatorContacts/"; 
            setIsSavingItemContacts(true);
        }
        if (part == "identifiers") { 
            updateItemURL = "/umbraco/api/RIMSRegistrations/OperatorIdentifiers/"; 
            setIsSavingItemIdentifiers(true);
        }
        if (part == "edit") { 
            updateItemURL = "/umbraco/api/RIMSRegistrations/Operators/"; 
            method = "PUT";
            setIsSavingItemEdit(true);
            updatedItem.AssignedTo = localCurrentItem.AssignedTo != -1 ? localCurrentItem.AssignedTo : null;
        }
        if (part == "assign-alerts") { 
            updateItemURL = "/umbraco/api/RIMSRegistrations/OperatorAlerts/"; 

            updatedItem.AssignedTo = localCurrentItem.AssignedTo != -1 ? localCurrentItem.AssignedTo : null;
            setIsSavingItemAssignPriorityAlerts(true);
        }
        if (part == "certificate-settings") {
            updateItemURL = "/umbraco/api/RIMSRegistrations/OperatorCertificateSettings/";
            setIsSavingItemCertificateSettings(true);
        }



        let requestOptions = {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedItem)
        };

        fetch(updateItemURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                if (result.Id) {

                    // Update the item in the existing item array
                    const updatedDataArray = AppContext.data.map((item) =>
                        item.Id === result.Id ? result : item
                    );
                    AppContext.setData(updatedDataArray);


                    // Update current item

                    let objectPartlyUpdated = AppContext.currentItem;

                    if (part == "notes") {
                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            Notes: result.Notes
                        };

                        setIsEditModeNote(false);

                        setIsShowingSaveMessageNotes(true);
                    }



                    if (part == "contacts") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            PrimaryContactFirstName: result.PrimaryContactFirstName,
                            PrimaryContactLastName: result.PrimaryContactLastName,
                            PrimaryContactEmail: result.PrimaryContactEmail,
                            Address: result.Address,
                            City: result.City,
                            ZipCode: result.ZipCode,
                        };

                        setIsShowingSaveMessageContacts(true);
                    }


                    if (part == "identifiers") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            NumberDUNS: result.NumberDUNS,
                            USANumberFEI: result.USANumberFEI,
                            EUNumberSRN: result.EUNumberSRN,
                        };

                        setIsShowingSaveMessageIdentifiers(true);
                    }


                    if (part == "edit") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            Name: result.Name,
                            CountryId: result.CountryId,
                            CountryName: result.CountryName,
                            Roles: result.Roles,
                            Authority: result.Authority,
                            CustomFieldsAnswers: result.CustomFieldsAnswers,
                            AssignedTo: result.AssignedTo,
                        };

                        setIsShowingSaveMessageEdit(true);
                    }


                    if (part == "assign-alerts") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            AssignedTo: result.AssignedTo,
                            Months: result.Months,
                        };

                        setIsShowingSaveMessageAssignPriorityAlerts(true);
                    }


                    if (part == "certificate-settings") {

                        objectPartlyUpdated = {
                            ...objectPartlyUpdated,
                            ExpiryDate: result.ExpiryDate,
                            EstablishmentRegistrationReference: result.EstablishmentRegistrationReference,
                        };

                        setIsShowingSaveMessageCertificateSettings(true);
                    }


                    AppContext.setCurrentItem(objectPartlyUpdated);



                    
                    setIsEditMode(false);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsSavingItemNotes(false);
                setIsSavingItemContacts(false);
                setIsSavingItemIdentifiers(false);
                setIsSavingItemEdit(false);
                setIsSavingItemAssignPriorityAlerts(false);
                setIsSavingItemCertificateSettings(false);

                setIsSavingItem(false);
            });
    };









    const loadCountries = () => {

        let countriesUrl = "/umbraco/api/RIMSProducts/Countries";

        let requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        fetch(countriesUrl, requestOptions)
            .then((response) => {
                checkResponseError(response);
                return response.json();
            })
            .then((result) => {
                if (result) {

                    result.sort((a, b) => a.CountryName.localeCompare(b.CountryName));

                    setCountries(result);
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    };



    const checkResponseError = (response) => {

        if (!response.ok) {
            if (response.status === 401)
                document.dispatchEvent(new Event("api:unauthorized"));

            throw new Error("Network response was not ok");
        }

    }



    // On parent change of the details pane status "restart" the popup
    useEffect(() => {

        if (AppContext.isPaneOpen == true) {
            // Immediately activate popup, but wait a bit to trigger the open animation
            setItemDetailsPaneActive(true);
            setTimeout(() => { setItemDetailsPaneOpenEffect(true); }, 100);
        }
        else {
            // Immediately do the hide effect but wait 300 to deactivate the popup
            setItemDetailsPaneOpenEffect(false);
            setTimeout(() => { setItemDetailsPaneActive(false); }, 300);
        }

    }, [AppContext.isPaneOpen]);


    const reinitialize = () => {
        changeTab("information");
        setAutoCallOverviewFunction(false);
        setSelectedPDFTab("main");
        setIsUploadingFile(false);
        setIsDeletingFile(false);
        setIsSavingItem(false);
        AppContext.setIsShowingDeleteConfirmation(false);

        loadCountries();

        setIsShowingSaveMessage(false);

        setIsEditMode(false);

        reloadLocalContext();

    }


    const reloadLocalContext = () => {

        setLocalCurrentItem({ AssignedTo: -1 });

    }

    useEffect(() => {

        if (itemDetailsPaneActive)
            reinitialize();

    }, [itemDetailsPaneActive]);


    useEffect(() => {

        if(!itemDetailsPaneOpenEffect)
            setShowItemContextMenu(false);

    }, [itemDetailsPaneOpenEffect])

    useEffect(() => {
        if (isEditMode && AppContext.currentItem) {
            setLocalCurrentItem({ ...AppContext.currentItem });
        }
    }, [isEditMode, AppContext.currentItem]);


    const openContextualMenu = () => {
        setShowItemContextMenu(!showItemContextMenu);
    };



    useEffect(() => {

        const handleClickOutside = (e) => {

            if (contextMenuButton.current && contextMenuButton.current.contains(e.target) ||
                contextMenu.current && contextMenu.current.contains(e.target) ||
                versionsMenuButton.current && versionsMenuButton.current.contains(e.target) ||
                versionsMenuOptions.current && versionsMenuOptions.current.contains(e.target)
            )
                return;

            setIsVersionDropdownOpen(false);
            setShowItemContextMenu(false);
            AppContext.setIsShowingDeleteConfirmation(false);

        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    




    /*
        When in the view/edit pane, when you click a field this will set edit mode on for that field
    */
    const enableTaskFormFieldEdit = (field, e) => {
        e.stopPropagation();
        let newObj = { ...isEditingField, [field]: true };
        setIsEditingField(newObj);
    };



    /*
        Disable all editable fields in the view/edit form
    */
    const disableAllItemFormFieldsEdit = () => {
        let newObj = { ...isEditingField };
        for (let prop in newObj) {
            newObj[prop] = false;
        }
        setIsEditingField(newObj);
    };

    
    const onDrop = useCallback((acceptedFiles) => {

        const formData = new FormData();
        acceptedFiles.forEach(file => formData.append('files', file));

        let requestOptions = {
            method: 'POST',
            body: formData,
        };


        setIsUploadingFile(true);

        let attachmentUrl = "/Umbraco/Api/Compliance/Upload/?complianceType=" + AppContext.ComplianceType + "&uniqueId=" + AppContext.currentItem.UniqueId;

        fetch(attachmentUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {
                if (data) {

                    // Update item
                    AppContext.setCurrentItem({ ...AppContext.currentItem, MedboardResourceId: data });

                    // Update list
                    // Update list
                    AppContext.setData(list =>
                        list.map(item =>
                            item.Id == AppContext.currentItem.Id ? { ...item, MedboardResourceId: data } : item
                        )
                    );
                    
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setIsUploadingFile(false);
            });

    }, [AppContext.currentItem]);



    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': [], // PDF
        },
        multiple: false,
    });




    // Canceling edit changes
    const cancelEdit = () => {

        AppContext.setCurrentItem(AppContext.originalItem);
        setIsEditMode(false);
        setVersion(v => v + 1);

    }

    // Canceling edit mode changes
    const cancelEditNote = () => {

        AppContext.setCurrentItem(prev => ({ ...prev, Note: AppContext.originalItem.Note }));
        setIsEditModeNote(false);
        setVersion(v => v + 1);

    }




    const toggleEditMode = () => {

        setIsEditMode(!isEditMode);

        setIsShowingSaveMessage(false);
    }


    const toggleEditModeNote = () => {

        setIsEditModeNote(!isEditModeNote);

        setIsShowingSaveMessageNotes(false);
    }



    const changeTab = (tab) => {

        setIsShowingSaveMessage(false);

        setIsShowingSaveMessageNotes(false);
        setIsShowingSaveMessageContacts(false);
        setIsShowingSaveMessageIdentifiers(false);
        setIsShowingSaveMessageEdit(false);
        setIsShowingSaveMessageAssignPriorityAlerts(false);
        setIsShowingSaveMessageCertificateSettings(false);

        setVisibleDetailsTab(tab);
    }


    const closePane = () => {

        AppContext.closePane();

    }




    

    const deepEqual = (a, b) => {
        if (a === b) return true;

        if (
            typeof a !== "object" || a === null ||
            typeof b !== "object" || b === null
        ) {
            return false;
        }

        const keysA = Object.keys(a);
        const keysB = Object.keys(b);

        if (keysA.length !== keysB.length) return false;

        for (let key of keysA) {
            if (!keysB.includes(key)) return false;

            if (!deepEqual(a[key], b[key])) return false;
        }

        return true;
    };



    


    const roles = [
        { Id: 1, Role: "Legal Manufacturer" },
        { Id: 2, Role: "Importer" },
        { Id: 3, Role: "Authorised Representative" },
        { Id: 4, Role: "Distributor" },
        { Id: 5, Role: "Physical Manufacturer" },
        { Id: 6, Role: "Reprocessor" },
        { Id: 7, Role: "Relabeler" },
        { Id: 8, Role: "Other" },
        { Id: 9, Role: "System or Procedure Pack Producer (SPPP)" },
    ];


    const tabs = [
        { title: "Operator Details", tab: "information" },
        { title: "Registrations", tab: "registrations" },
        { title: "Files", tab: "documents" },
        { title: "Comments", tab: "comments" },
        { title: "History", tab: "history" },
        { title: "Notes", tab: "notes" },
        { title: "Tasks", tab: "task-manager" },
        { title: "Compliance", tab: "compliance" },
    ];


    const usersList = [{ Id: -1, Name: "Choose an option" }, ...AppContext.users];

    let localContext = {

        currentItem: localCurrentItem,
        setCurrentItem: setLocalCurrentItem

    }

    const displayFieldOnly = true;

    let fullWidthPane = true;

    return (
        <>

            {itemDetailsPaneActive ? 
                
                <div
                    style={{ height: "100vh", overflow: "auto", backgroundColor: "#f7fafc" }}
                    className={`${fullWidthPane ? "slide-pane-full-width" : "slide-pane"} ${itemDetailsPaneOpenEffect ? "open" : ""}`}
                >
                    <div className="content">

                        
                        <p style={{ color: "#555", fontSize: "11px" }}>
                            <span className="breadcrumb-link" style={{ marginRight: "5px" }} onClick={() => closePane()}>Operators</span>
                            {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? null :
                                <>
                                    &gt; <span style={{ marginLeft: "5px" }}> {AppContext.currentItem.Name}</span>
                                </>
                            }
                        </p>


                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}
                        {/* NEW LAYOUT */}


                        <div className="item-details-content">

                            <div className="item-details-content-tabs">

                                <div className="nav" style={{ display: "flex", flexDirection: "column", gap: "4px" }} >

                                    {tabs.map((tab, index) => {
                                        if (tab.onlyAdmin && AppContext.userRole !== "Admin") {
                                            return null;
                                        }

                                        return (
                                            <a
                                                key={index} // better than index if tab.tab is unique
                                                onClick={() => changeTab(tab.tab)}
                                                className={`nav-item item-details-menu-tab ${visibleDetailsTab === tab.tab ? "active" : ""
                                                    }`}
                                            >
                                                {tab.title}
                                            </a>
                                        );
                                    })}

                                </div>

                            </div>


                            <div className="item-details-content-content">

                                {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                                    <>
                                        <LayoutComponents.PageLoading />
                                    </>
                                ) : (
                                    <>

                                        {/* Header */}

                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                                <h2 style={{ margin: 0, fontSize: "24px", fontWeight: 700, color: "#1a202c", display: "flex", alignItems: "center", gap: "10px" }}>
                                                    <i className="fas fa-clipboard" style={{ color: "#2b6cb0" }} />
                                                    Operator
                                                </h2>

                                                <span style={{ fontSize: "16px", color: "#4a5568", fontWeight: 600, background: "#edf2f7", padding: "4px 12px", borderRadius: "6px" }}>
                                                    {AppContext.currentItem?.Name}
                                                </span>
                                            </div>

                                            <div style={{ display: "flex", gap: "8px" }}>

                                                    {visibleDetailsTab == "information" ? <>

                                                        {AppContext.userRole == "Admin" ? <>

                                                            {isEditMode ?

                                                                <div id="buttom-bar" >

                                                                    {/* FORMS BUTTONS */}

                                                                    <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                        <div className="action-button-bar-left"></div>
                                                                        <div className="action-button-bar-center"></div>

                                                                        <div className="action-button-bar-right">

                                                                            {!isSavingItem ? (
                                                                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                                    <button
                                                                                        className="action-button save-button"
                                                                                        onClick={() => cancelEdit()}
                                                                                        onMouseOver={(e) => {
                                                                                            e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                            e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                        }}
                                                                                        onMouseOut={(e) => {
                                                                                            e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                            e.currentTarget.style.borderColor = "#dee2e6";
                                                                                        }}
                                                                                        style={{
                                                                                            display: "inline-flex",
                                                                                            alignItems: "center",
                                                                                            padding: "6px 14px",
                                                                                            cursor: "pointer",
                                                                                            transition: "all 0.2s ease-in-out",
                                                                                            color: "#5f6368",
                                                                                            border: "1px solid #dee2e6",
                                                                                            backgroundColor: "#ffffff",
                                                                                            whiteSpace: "nowrap",
                                                                                            outline: "none"
                                                                                        }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                    <button
                                                                                        className="action-button save-button"
                                                                                        onClick={saveCurrentItem}
                                                                                    >
                                                                                        Save
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    <LoadingSpinnerImage />
                                                                                </>
                                                                            )}


                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                :
                                                                <>
                                                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                        <div style={{
                                                                            flex: 1,
                                                                            justifyContent: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginRight: "20px",
                                                                        }}>
                                                                            {isShowingSaveMessage ?
                                                                                <span className="save-message-shown">
                                                                                    Save successful!
                                                                                </span>
                                                                                : null}
                                                                        </div>

                                                                        
                                                                        <div>
                                                                            <div className="view-task-field" style={{
                                                                                textAlign: "right",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginBottom: "0px",
                                                                            }}>
                                                                                <span onClick={() => toggleEditMode()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                                    <i className="far fa-edit pointer g-mr-8"></i>Edit Operator
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                </>
                                                            }

                                                        </>

                                                            : null}

                                                    </> : null}











                                                    {visibleDetailsTab == "notes" ? <>

                                                        {AppContext.userRole == "Admin" ? <>

                                                            {isEditModeNote ?


                                                                <div id="buttom-bar" >

                                                                    {/* FORMS BUTTONS */}

                                                                    <div className="action-button-bar" style={{ marginTop: "0px" }}>

                                                                        <div className="action-button-bar-left"></div>
                                                                        <div className="action-button-bar-center"></div>

                                                                        <div className="action-button-bar-right">

                                                                            <div style={{display: "flex", flexDirection: "row"}}>

                                                                                {!isSavingItemNotes ? (
                                                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "right", gap: "8px" }}>
                                                                                        <button
                                                                                            className="action-button save-button"
                                                                                            onClick={() => cancelEditNote()}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                                                                                e.currentTarget.style.borderColor = "#c1c4c8";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#ffffff";
                                                                                                e.currentTarget.style.borderColor = "#dee2e6";
                                                                                            }}
                                                                                            style={{
                                                                                                display: "inline-flex",
                                                                                                alignItems: "center",
                                                                                                padding: "6px 14px",
                                                                                                cursor: "pointer",
                                                                                                transition: "all 0.2s ease-in-out",
                                                                                                color: "#5f6368",
                                                                                                border: "1px solid #dee2e6",
                                                                                                backgroundColor: "#ffffff",
                                                                                                whiteSpace: "nowrap",
                                                                                                outline: "none"
                                                                                            }}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                        <button
                                                                                            className="action-button save-button"
                                                                                            onClick={() => saveCurrentItemPartial("notes")}
                                                                                            onMouseOver={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#1a73e8";
                                                                                            }}
                                                                                            onMouseOut={(e) => {
                                                                                                e.currentTarget.style.backgroundColor = "#1a73e8";
                                                                                            }}
                                                                                            style={{
                                                                                                display: "inline-flex",
                                                                                                alignItems: "center",
                                                                                                padding: "6px 14px",
                                                                                                cursor: "pointer",
                                                                                                transition: "all 0.2s ease-in-out",
                                                                                                color: "#ffffff",
                                                                                                border: "1px solid #1a73e8",
                                                                                                backgroundColor: "#1a73e8",
                                                                                                whiteSpace: "nowrap",
                                                                                                outline: "none"
                                                                                            }}
                                                                                        >
                                                                                            Save
                                                                                        </button>
                                                                                    </div>
                                                                                ) : (
                                                                                    <>
                                                                                        <LoadingSpinnerImage />
                                                                                    </>
                                                                                )}


                                                                            </div>


                                                                        </div>


                                                                    </div>

                                                                </div>



                                                                :
                                                                <>
                                                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                                                        <div style={{
                                                                            flex: 1,
                                                                            justifyContent: "right",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            marginRight: "20px",
                                                                        }}>
                                                                            {isShowingSaveMessageNotes ?
                                                                                <span className="save-message-shown">
                                                                                    Save successful!
                                                                                </span>
                                                                                : null}
                                                                        </div>



                                                                        <div>
                                                                            <div className="view-task-field" style={{
                                                                                textAlign: "right",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginBottom: "0px",
                                                                            }}>
                                                                                <span onClick={() => toggleEditModeNote()} value="EDIT" style={{ borderRadius: "20px" }} className="edit-rims-edit-button">
                                                                                    <i className="fas fa-edit g-pr-8"></i>Edit Notes
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>



                                                                </>
                                                            }

                                                        </> : null}

                                                    </> : null}















                                                    <button ref={contextMenuButton} onClick={openContextualMenu} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-ellipsis-v" />
                                                </button>

                                                <button onClick={() => closePane()} style={{ border: "1px solid #cbd5e0", background: "white", borderRadius: "6px", padding: "6px 10px", cursor: "pointer", color: "#4a5568" }}>
                                                    <i className="fas fa-times" />
                                                </button>
                                            </div>
                                        </div>





                                        {/* Main content */}

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>


                                            {/* INFORMATION DASHBOARD */}

                                            {visibleDetailsTab == "information" ?

                                                <>

                                                    {/* LEFT */}

                                                    <div style={{ flex: 2, minWidth: "400px", display: "flex", flexDirection: "column", gap: "24px" }}>
                                                        <LayoutComponents.InfoBlock>
                                                                <div style={{ display: "flex", gap: "40px" }}>

                                                                    <div>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Country / Jurisdiction
                                                                        </span>

                                                                        <span style={{ fontSize: isEditMode ? "13px" : "16px", fontWeight: isEditMode ? 500 : 600, color: "#2d3748", display: "flex", alignItems: "center", gap: "6px" }}>
                                                                            {isEditMode ? (
                                                                                <FieldTypes.ItemDetailsField_Dropdown AppContext={AppContext} fieldId={"CountryId"} fieldName={"CountryName"} fieldTitle={"Country"} LOV={countries} LOVIdField={"CountryId"} LOVNameField={"CountryName"} mandatory={false} enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                            ) : (
                                                                                AppContext.currentItem?.CountryName ? (
                                                                                    <>
                                                                                        <img
                                                                                            className="countryFlag"
                                                                                            src={AppContext.currentItem?.FlagLink}
                                                                                            style={{ height: "20px", marginRight: "5px" }}
                                                                                            alt=""
                                                                                        />
                                                                                        {AppContext.currentItem?.CountryName}
                                                                                    </>
                                                                                ) : (
                                                                                    "---"
                                                                                )
                                                                            )}
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Operator Name
                                                                        </span>

                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Name"} fieldTitle={"Name"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Operator Reference
                                                                        </span>

                                                                        <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"EstablishmentRegistrationReference"} fieldTitle={"Reference"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Operator Role
                                                                        </span>

                                                                        {isEditMode ? (
                                                                            <FieldTypes.ItemDetailsField_MultiSelect key={`role_${version}`} AppContext={AppContext} fieldTitle={"Roles"} fieldName={"Roles"} selectedItems={AppContext.currentItem.Roles} LOV={roles} LOVIdField={"Id"} LOVNameField={"Role"} noneIsAll={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        ) : (
                                                                            <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                                                                                {AppContext.currentItem.Roles?.map((role, index) => (
                                                                                    <span key={index} className="operator-badge-role">
                                                                                        {roles.find(item => item.Id == role)?.Role}
                                                                                    </span>
                                                                                ))}
                                                                            </span>
                                                                        )}
                                                                    </div>

                                                                    <div style={{ borderLeft: "1px solid #e2e8f0", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#a0aec0", marginBottom: "4px" }}>
                                                                            Authority
                                                                        </span>

                                                                        {isEditMode ? (
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Authority"} fieldTitle={"Competent Authority"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />
                                                                        ) : (
                                                                            <span style={{ fontSize: "15px", fontWeight: 600, color: "#4a5568", fontFamily: "monospace" }}>
                                                                                {AppContext.currentItem?.Authority ? AppContext.currentItem?.Authority : "---"}
                                                                            </span>
                                                                        )}
                                                                    </div>

                                                                </div>
                                                        </LayoutComponents.InfoBlock>


                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                Primary Contact Information
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                                                                <div style={{ paddingLeft: "14px", borderLeft: "4px solid #3398dc" }}>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                        Full Name
                                                                    </label>

                                                                            {isEditMode ? <>
                                                                                <div style={{display: "flex", flexDirection: "row"}}>
                                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"PrimaryContactFirstName"} fieldTitle={"First Name"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} placeholder="First name" />
                                                                                    <span>&nbsp;</span>
                                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"PrimaryContactLastName"} fieldTitle={"Last Name"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} placeholder="Last name" />
                                                                                </div>

                                                                            </> : <>

                                                                                {AppContext.currentItem?.PrimaryContactFirstName || AppContext.currentItem?.PrimaryContactLastName ?
                                                                                    <>
                                                                                        {AppContext.currentItem?.PrimaryContactFirstName}{" "}{AppContext.currentItem?.PrimaryContactLastName}
                                                                                    </>
                                                                                : "---"}
                                                                        </>}

                                                                </div>

                                                                <div style={{ paddingLeft: "14px", borderLeft: "4px solid #2a6e92" }}>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                        Email
                                                                    </label>
                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"PrimaryContactEmail"} fieldTitle={"Email"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} placeholder="Email" />

                                                                </div>

                                                                <div style={{ paddingLeft: "14px", borderLeft: "4px solid #203864" }}>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 700, textTransform: "uppercase", color: "#718096", marginBottom: "4px" }}>
                                                                        Address
                                                                    </label>

                                                                        {isEditMode ? <>
                                                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                                                <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Address"} fieldTitle={"Address"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} placeholder="Address" />
                                                                                <span>&nbsp;</span>
                                                                                <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"ZipCode"} fieldTitle={"ZipCode"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} placeholder="ZipCode" />
                                                                                <span>&nbsp;</span>
                                                                                <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"City"} fieldTitle={"City"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} placeholder="City" />
                                                                            </div>
                                                                        </> : <>
                                                                            {AppContext.currentItem?.Address || AppContext.currentItem?.ZipCode || AppContext.currentItem?.City ?
                                                                                <>
                                                                                    {AppContext.currentItem?.Address}<br />
                                                                                    {AppContext.currentItem?.ZipCode}<br />
                                                                                    {AppContext.currentItem?.City}
                                                                                </>
                                                                            : "---"}
                                                                        </>}


                                                                        

                                                                </div>

                                                            </div>

                                                        </LayoutComponents.InfoBlock>


                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                Analytics
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "row", gap: "20px", flexWrap: "wrap" }}>

                                                                    <div style={{ flex: 1, }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Registrations
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.RegistrationCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("registrations")}>{AppContext.currentItem?.RegistrationCount ?? 0}</span>
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Documents
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.DocumentCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("documents")}>{AppContext.currentItem?.DocumentCount ?? 0}</span>
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Open Tasks
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.TaskCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("task-manager")}>{AppContext.currentItem?.TaskCount ?? 0}</span>
                                                                        </span>
                                                                    </div>

                                                                    <div style={{ flex: 1, borderLeft: "1px solid #eee", paddingLeft: "40px" }}>
                                                                        <span style={{ display: "block", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase", color: "#555", marginBottom: "4px" }}>
                                                                            Comments
                                                                        </span>
                                                                        <span style={{
                                                                            fontSize: "20px",
                                                                            fontWeight: 600,
                                                                            color: AppContext.currentItem?.CommentCount > 0 ? "rgb(32, 56, 100)" : "#999",
                                                                            display: "block",
                                                                            lineHeight: 1
                                                                        }}>
                                                                            <span className="pointer" onClick={() => changeTab("comments")}>{AppContext.currentItem?.CommentCount ?? 0}</span>
                                                                        </span>
                                                                    </div>

                                                            </div>

                                                        </LayoutComponents.InfoBlock>

                                                        {AppContext.enableCustomFields ?
                                                                <LayoutComponents.InfoBlock>

                                                                    <h4 style={{ margin: "0 0 20px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096", borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                                                                        Custom fields
                                                                    </h4>

                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                                                                        <FieldTypes.FieldType_CustomUserFieldsView globalContext={AppContext} isEditing={isEditMode} />
                                                                
                                                                    </div>

                                                                </LayoutComponents.InfoBlock>
                                                        : null}
                                                    </div>

                                                    {/*RIGHT */}

                                                    <div style={{ flex: 1, minWidth: "280px", display: "flex", flexDirection: "column", gap: "24px" }}>

                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                Country Identifiers
                                                            </h4>
                                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                        USA FEI Number
                                                                    </label>
                                                                        <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"USANumberFEI"} fieldTitle={"USA FEI Number"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} isNumeric={true} minLength={0} maxLength={10} />
                                                                </div>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "4px" }}>
                                                                        EU SRN Number
                                                                    </label>
                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"EUNumberSRN"} fieldTitle={"EU SRN Number"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} minLength={0} maxLength={15} />
                                                                </div>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                        DUNS Number
                                                                    </label>
                                                                    <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"NumberDUNS"} fieldTitle={"DUNS Number"} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} isNumeric={true} minLength={0} maxLength={9} />
                                                                </div>

                                                            </div>


                                                        </LayoutComponents.InfoBlock>

                                                        <LayoutComponents.InfoBlock>
                                                            <h4 style={{ margin: "0 0 16px 0", fontSize: "14px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", color: "#718096" }}>
                                                                Assignments & Alerts
                                                            </h4>

                                                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "6px" }}>
                                                                            Assigned to
                                                                    </label>

                                                                    {isEditMode ? <>
                                                                        <FieldTypes.ItemDetailsField_Dropdown AppContext={localContext} fieldId={"AssignedTo"} fieldName={"_AssignedTo"} fieldTitle={"Assigned User"} LOV={usersList} LOVIdField={"Id"} LOVNameField={"Name"} mandatory={true} enableSearch={true} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                    </> : <>
                                                                        <div style={{ display: "flex", alignItems: "center"}}>
                                                                            {AppContext.currentItem?.AssignedTo ?
                                                                                <FieldTypes.FieldType_FullUser
                                                                                    users={AppContext.users}
                                                                                    value={AppContext.currentItem.AssignedTo}
                                                                                /> : "---"}
                                                                        </div>

                                                                    </>}

                                                                </div>

                                                                <div>
                                                                        {/* Existing Label */}
                                                                        <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                            Alert Time (Months before expiration)
                                                                        </label>


                                                                        {isEditMode ? <>
                                                                            <FieldTypes.ItemDetailsField_Text AppContext={AppContext} field={"Months"} fieldTitle={"Alert Time (Months)"} isNumeric={true} mandatory={false} forceIsEditing={isEditMode} displayFieldOnly={displayFieldOnly} />

                                                                        </> : <>
                                                                            {/* Value and Notification Calculation */}
                                                                            {AppContext.currentItem?.Months ? (
                                                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                                                                                    <span className="fas fa-bell"></span>

                                                                                    {/* 2. Display the Months */}
                                                                                    <span>{AppContext.currentItem.Months} Month(s)</span>

                                                                                    {/* 3. Display Calculated Notification Date */}
                                                                                    {AppContext.currentItem.ExpiryDate && (
                                                                                        <span style={{ fontSize: "12px", color: "#718096" }}>
                                                                                            (Alert Date: {
                                                                                                (() => {
                                                                                                    const expiry = new Date(AppContext.currentItem.ExpiryDate);
                                                                                                    expiry.setMonth(expiry.getMonth() - AppContext.currentItem.Months);

                                                                                                    // Get the individual date components
                                                                                                    const day = String(expiry.getDate()).padStart(2, '0');
                                                                                                    const month = expiry.toLocaleString('en-US', { month: 'short' });
                                                                                                    const year = expiry.getFullYear();

                                                                                                    // Combine them into the desired format
                                                                                                    return `${day} ${month}, ${year}`;
                                                                                                })()
                                                                                            })
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            ) : (
                                                                                "---"
                                                                            )}

                                                                        </>}



                                                                </div>

                                                                <div>
                                                                    <label style={{ display: "block", fontSize: "11px", fontWeight: 600, color: "#a0aec0", textTransform: "uppercase", marginBottom: "2px" }}>
                                                                        Expiry Date
                                                                    </label>
                                                                    
                                                                    <FieldTypes.ItemDetailsField_DateUTC AppContext={AppContext} field={"ExpiryDate"} fieldTitle={"Expiry Date"} mandatory={false} forceIsEditing={isEditMode} warning={true} displayFieldOnly={displayFieldOnly} />


                                                                </div>

                                                            </div>
                                                        </LayoutComponents.InfoBlock>

                                                    </div>


                                                </>
                                                : null}






                                            {/* REGISTRATIONS */}

                                            {visibleDetailsTab == "registrations" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>

                                                    <div style={{ marginBottom: "20px" }}>

                                                        <RegistrationsList AppContext={AppContext} />

                                                    </div>

                                                </div>

                                            }





                                            {/* DOCUMENTS */}

                                            {visibleDetailsTab == "documents" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", }}>

                                                    <div style={{ marginBottom: "20px" }}>
                                                            <DocumentsList AppContext={AppContext} refresh={documentListRefresh} setRefresh={setDocumentListRefresh}
                                                                customButtons=
                                                                {
                                                                        AppContext.userRole === "Admin"
                                                                            ? [{ Name: "Add file", callback: openDocumentPopup, cssIcon: "fas fa-plus-circle" }]
                                                                        : []
                                                                } />
                                                    </div>

                                                </div>

                                            }




                                            {/* COMMENTS */}

                                            {visibleDetailsTab == "comments" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>

                                                    <div style={{ marginBottom: "20px" }}>
                                                        <CommentsPanel AppContext={AppContext} operatorId={AppContext.currentItem.Id} />
                                                    </div>

                                                </div>

                                            }





                                            {/* HISTORY */}

                                            {visibleDetailsTab == "history" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>

                                                    <div style={{ marginBottom: "20px" }}>
                                                        <CertificateHistory certificateId={AppContext.currentItem.CertificateId} users={AppContext.users} />
                                                    </div>

                                                </div>

                                            }





                                            {/* TASKS */}

                                            {visibleDetailsTab == "task-manager" &&

                                                <div style={{ height: "100%", overflow: "auto", width: "100%", backgroundColor: "white", padding: "5px", borderRadius: "15px" }}>
                                                    <TaskManager
                                                        emitter={new EventEmitter()}
                                                        paramEntityType="countryregistration-operator"
                                                        paramEntityId={AppContext.currentItem.Id}
                                                        paramCompanyId={AppContext.currentCompanyId}
                                                        paramUserId={AppContext.currentUserId}
                                                        paramIsSlimVersion={true}
                                                        paramExternalLinkedObjects={[{ EntityType: "countryregistration-operator", EntityId: AppContext.currentItem.Id }]}
                                                        paramHasLimitedWidth={true} />
                                                </div>
                                            }






                                            {/* ATTACHMENTS */}

                                            {visibleDetailsTab == "attachments" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>
                                                    <Attachments EntityType={AppContext.entityType} EntityId={AppContext.currentItem.Id} users={AppContext.users} userRole={AppContext.userRole} />
                                                </div>
                                            </>}





                                            {/* Compliance */}

                                            {visibleDetailsTab == "compliance" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>
                                                    <OperatorsComplianceTables
                                                        AppContext={AppContext}
                                                        operatorId={AppContext.currentItem.Id}
                                                    />
                                                </div>
                                            </>}









                                            {/* Notes  */}

                                            {visibleDetailsTab == "notes" && <>
                                                <div style={{ height: "100%", overflow: "auto", width: "100%"  }}>


                                                        <div style={{display: "flex", flexDirection: "row"}}>
                                                            
                                                            <div style={{ width: "100%" }}>

                                                                <LayoutComponents.InfoBlock>

                                                                {isEditModeNote ? <>
                                                                    <FieldTypes.ItemDetailsField_Text key={version} AppContext={AppContext} field={"Note"} fieldTitle={"Notes"} mandatory={false} richText={true} forceIsEditing={isEditModeNote} displayFieldOnly={displayFieldOnly} />

                                                                </> : <>

                                                                    <div dangerouslySetInnerHTML={{ __html: AppContext.currentItem?.Note }} />

                                                                    </>}

                                                                </LayoutComponents.InfoBlock>
                                                            </div>
                                                        </div>


                                                </div>
                                            </>}








                                        </div>


                                    </>
                                )}

                            </div>

                        </div>










                    </div>
                </div>
            
            : null}



            




            {showItemContextMenu && (
                <div
                    ref={contextMenu}
                    style={{
                        position: "fixed",
                        top: `50px`,
                        right: `70px`,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "4px",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        borderRadius: "15px",

                    }}
                >

                    {/* DELETE */}
                    {AppContext.userRole === "Admin" ? (
                        !AppContext.isShowingDeleteConfirmation ? (
                            <div className="context-menu-option" onClick={() => AppContext.setIsShowingDeleteConfirmation(true)}>
                                <i className="far fa-trash-alt"></i> Delete this item
                            </div>
                        ) : (
                            AppContext.isDeletingItem ? (
                                <LoadingSpinnerImage />
                            ) : (
                                <div className="context-menu-option context-delete-option" onClick={AppContext.deleteCurrentItem}>
                                    <i className="far fa-trash-alt"></i> Confirm delete?
                                </div>
                            )
                        )
                    ) : (
                        <div className="context-menu-option disabled">
                            <i className="far fa-trash-alt"></i> Delete (No Permission)
                        </div>
                    )}


                </div>
            )}





            {isShowingDocumentAddPopup ?
                <UploadPdfPopup certificateId={AppContext.currentItem.CertificateId} onSuccess={successDocumentUploaded} onClose={closeDocumentPopup} />
            : null}






        </>
    );
};










const ItemDetailsField_MultiSelect = ({ AppContext, fieldTitle, fieldId, fieldName, selectedItems = [], LOV = [], LOVIdField, LOVNameField, mandatory = false, noneIsAll = true, itemLink = null, forceIsEditing = null }) => {

    const [formState, setFormState] = useState({});
    const [isEditingField, setIsEditingField] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [possibleValuesObject, setPossibleValuesObject] = useState({});

    const dropdownRefs = useRef({});


    useEffect(() => {
        const initialState = {};

        initialState[fieldName] = selectedItems;

        setFormState(initialState);

        let tmp = {
            Alias: fieldName,
            Name: "",
            Items: LOV.map(pv => ({
                Text: pv[LOVNameField],
                Value: pv[LOVIdField],
                Disabled: false,
                Group: null,
                Selected: false
            }))
        };

        setPossibleValuesObject(tmp);

    }, []);



    useEffect(() => {

        AppContext.setCurrentItem({ ...AppContext.currentItem, [fieldName]: formState[fieldName] });

    }, [formState]);


    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditingField(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditingField(forceIsEditing);

    }, [forceIsEditing]);


    return <>

        <div className="view-task-field">

            <div className="view-task-field-line">

                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{width: "100%", position: "relative"}}>

                        {isEditingField === false ? (

                            <>
                                {selectedItems.length == 0 ? 
                                    <span
                                        className={`editable-field-span`}
                                        onClick={(e) =>
                                            changeIsEditingField(true)
                                        }
                                    >
                                        <FieldTypes.ItemDetailsField_EmptyValue />    
                                    </span>
                                :
                                    <div className="selected-tags">
                                    
                                        {LOV.filter(item => selectedItems.includes(item[LOVIdField])).map((item, index) => (
                                            <span key={index} className="tag">
                                                {itemLink ? 
                                                    <a href={itemLink.replaceAll("[PARAM]", item[LOVIdField])} target="_blank">{item[LOVNameField]}</a>
                                                : 
                                                    <span>{item[LOVNameField]}</span>
                                                }
                                            </span>
                                        ))}

                                    </div>
                                }

                            </>

                        ) : (

                            <MultiSelectField field={possibleValuesObject}
                                formState={formState}
                                setFormState={setFormState}
                                fieldsConfig={[possibleValuesObject]}
                                searchValues={searchValues}
                                setSearchValues={setSearchValues}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownRefs={dropdownRefs}
                                noneIsAll={noneIsAll}
                                itemLink={itemLink}
                            />
                        )}



                    </div>

                </div>

            </div>

        </div>


    </>

}








const RegistrationsList = ({ AppContext }) => {

    let legalManufacturerFilter = window.legalManufacturerId ? { legalManufacturerId: window.legalManufacturerId } : {};

    return <>
    
        <GenericDataTable
            columns={[
                {
                    key: "IdCheckbox",
                    label: "",
                    sortable: false,
                    type: "checkbox",
                    size: "60px",
                },

                {
                    key: "Id", label: "Registration", sortable: false, size: "120px",

                    render: ({ row, value }) => (
                        <div style={{ textAlign: "center", width: "93px" }}>
                            <a
                                href={`/your-medboard/country-registrations/registrations/?&registrationId=${value}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    backgroundColor: "#f7fafc", padding: "0px 6px", borderRadius: "5px", border: "1px solid #e2e8f0",
                                    color: "#3182ce",
                                    fontWeight: "500"
                                }}
                            >
                                Open ↗
                            </a> </div>
                    ),

                },

                {
                    key: "ProductId", label: "Product Code", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_ProductCodeLink value={{ ProductId: row.ProductId, ProductSKUCode: row.ProductSKUCode, Archived: row.Archived }} />
                    ),
                },

                {
                    key: "ProductName", label: "Product Name", sortable: true, size: "300px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "FamilyId", label: "Product Family", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_FamilyLink value={{ FamilyId: row.FamilyId, FamilyName: row.FamilyName }} />
                    ),
                },

                {
                    key: "UDI", label: "UDI", sortable: true, size: "150px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "CountryId", label: "Country", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_Country value={{ CountryId: row.CountryId, CountryName: row.CountryName, FlagLink: row.FlagLink }} />
                    ),
                },

                {
                    key: "RiskClass", label: "Risk Class", sortable: true, size: "100px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_RiskClass value={value} />
                    ),
                },

                {
                    key: "Status", label: "Registration Status", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_RegistrationsStatus value={value} />
                    ),
                },

                {
                    key: "CountryRepresentatives", label: "Country Representative", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_MultipleOperatorsRepresentatives value={{ CountryRepresentatives: row.CountryRepresentatives, CountryRepresentativesIds: row.CountryRepresentativesIds }} />
                    ),
                },

                {
                    key: "CountryDistributors", label: "Country Distributor", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_MultipleOperatorsDistributors value={{ CountryDistributors: row.CountryDistributors, CountryDistributorsIds: row.CountryDistributorsIds }} />
                    ),
                },




                {
                    key: "Importers", label: "Country Importer", sortable: true, size: "250px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_MultipleOperatorsImporters value={{ Importers: row.Importers, ImportersIds: row.ImportersIds }} />
                    ),
                },

                {
                    key: "IssuedBy", label: "Registration Issued By", sortable: true, size: "200px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "ExpiryDate", label: "Expiry Date", sortable: true, size: "150px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_SimpleDate value={value} />
                    ),
                },

                {
                    key: "Notes", label: "Notes", sortable: true, size: "300px",

                    render: ({ row, value }) => (
                        <>{value}</>
                    ),
                },

                {
                    key: "Selling", label: "Selling", sortable: true, size: "100px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_CountryRegistrationSelling value={value} />
                    ),
                },



                {
                    key: "AssignedTo", label: "Assigned user", sortable: true, size: "150px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_User value={value} users={AppContext.users} />
                    ),
                },


                {
                    key: "Priority", label: "Priority", sortable: true, size: "100px",

                    render: ({ row, value }) => (
                        <FieldTypes.FieldType_RegistrationPriority value={value} />
                    ),
                },


            ]}
            fetchUrl="/umbraco/api/RIMSRegistrations/OperatorRegistrations/"
            enableDelete={AppContext.userRole == "Admin" ? true : false}
            deleteUrl="/umbraco/api/RIMSRegistrations/BulkRegistrations/?registrationIds="
            exportUrl="/umbraco/api/RIMSRegistrations/RegistrationsExport/?registrationIds="
            queryParams={{ operatorId: AppContext.currentItem.Id, ...legalManufacturerFilter }}
            exportFileName={`${AppContext.currentItem.Name}-registrations-export.xlsx`}
            rowTitleKey="ProductName"
            searchPlaceholder="Search Registrations"
            LoadingComponent={LoadingSpinnerImage}
            showTotalCount={true}
            totalCountUrl="/umbraco/api/RIMSRegistrations/OperatorRegistrationsCount/"
        />

    </>

}






const DocumentsList = ({ AppContext, refresh, setRefresh, customButtons = [] }) => {

    const [deletingId, setDeletingId] = useState(null);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [dropdownCoords, setDropdownCoords] = useState({ top: 0, right: 0 });
    const toggleDropdown = (id) => {
        if (openDropdownId === id) {
            setOpenDropdownId(null);
        } else {
            setOpenDropdownId(id);
        }
    };
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null); // Close the dropdown
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setOpenDropdownId]);

    const removeDocument = async (certificateFileId) => {
        try {
            setDeletingId(certificateFileId);

            await fetch(
                `/umbraco/api/RIMSRegistrations/Documents/?fileId=${certificateFileId}`,
                {
                    method: "DELETE"
                }
            );

            setRefresh(prev => prev + 1);
        }
        finally {
            setDeletingId(null);
            setConfirmDeleteId(null);
        }
    };
    const iconMap = {
        pdf: 'fas fa-file-pdf text-danger',
        doc: 'fas fa-file-word text-primary',
        docx: 'fas fa-file-word text-primary',
        xls: 'fas fa-file-excel text-success',
        xlsx: 'fas fa-file-excel text-success',
        ppt: 'fas fa-file-powerpoint text-warning',
        pptx: 'fas fa-file-powerpoint text-warning',
        png: 'fas fa-file-image text-info',
        jpg: 'fas fa-file-image text-info',
        jpeg: 'fas fa-file-image text-info',
        tiff: 'fas fa-file-image text-info',
        tif: 'fas fa-file-image text-info',
        ris: 'fas fa-file-alt text-info',
        txt: 'fas fa-file-alt text-info',
        csv: 'fas fa-file-alt text-success'
    };
    const getFileIcon = (filename) => {
        const ext = filename?.split('.').pop().toLowerCase();
        return iconMap[ext] || 'fa-file text-secondary';
    };
     return (
        <>
            <GenericDataTable
                columns={[
                    {
                        key: "Filename",
                        label: "Filename",
                        sortable: true,
                        size: "300px",
                        render: ({ row, value }) => {
                            const iconClass = getFileIcon(value);
                            return (
                                <>
                                    <i className={`${iconClass} g-mr-20 g-ml-10`}></i>
                                    <a
                                        href={`/umbraco/api/RIMSRegistrations/Document/?fileId=${row.CertificateFileId}&view=true`}
                                        title="View file"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ overflowWrap: "anywhere", wordBreak: "break-word"}}

                                    >
                                        {value}
                                    </a>
                                </>
                            );
                        },
                    },
                    {
                        key: "FileSize",
                        label: "Filesize (Bytes)",
                        sortable: true,
                        size: "100px",
                        render: ({ value }) => <>{value}</>, 
                    },
                    {
                        key: "UploadDate",
                        label: "Uploaded",
                        sortable: true,
                        size: "200px",
                        render: ({ row, value }) => {
                            if (!value) return <></>;
                            return <>{new Date(value).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</>;
                        },
                    },

                    {
                        key: "UploadedBy",
                        label: "Uploaded By",
                        sortable: true,
                        size: "150px",
                        render: ({ row, value }) => (
                            <FieldTypes.FieldType_User
                                value={value}
                                users={AppContext.users}
                            />
                        ),
                    },

                    {
                        key: "CertificateFileId",
                        label: "Options",
                        sortable: true,
                        size: "100px",
                        render: ({ row, value }) => {
                            const fileExtension = row.Filename?.split('.').pop()?.toLowerCase();
                            const isPdf = fileExtension === 'pdf';

                            return (
                                <div ref={openDropdownId === value ? dropdownRef : null}>
                                    <span
                                        title="More options"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const rect = e.currentTarget.getBoundingClientRect();
                                            setDropdownCoords({
                                                top: rect.bottom + 4,
                                                right: window.innerWidth - rect.right
                                            });
                                            toggleDropdown(value);
                                        }}
                                        style={{ cursor: "pointer", padding: "4px 8px" }}
                                    >
                                        <i className="fas fa-ellipsis-v"></i>
                                    </span>

                                    {openDropdownId === value && (
                                        <div style={{
                                            position: "fixed",
                                            right: `${dropdownCoords.right}px`,
                                            top: `${dropdownCoords.top}px`,
                                            backgroundColor: 'white',
                                            border: '1px solid #ccc',
                                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                            zIndex: 9999,
                                            borderRadius: "5px",
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column",
                                            minWidth: "160px"
                                        }}>
                                            {isPdf && (
                                                <a
                                                    href={`/umbraco/api/RIMSRegistrations/Document/?fileId=${value}&view=true`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="submissions-dropdown-item"
                                                    style={{ textDecoration: "none", padding: "8px 12px", color: "inherit", display: "flex", alignItems: "center" }}
                                                >
                                                    <i className="fas fa-eye" style={{ marginRight: "10px", width: "16px", textAlign: "center" }}></i> View file
                                                </a>
                                            )}

                                            <a
                                                href={`/umbraco/api/RIMSRegistrations/Document/?fileId=${value}`}
                                                className="submissions-dropdown-item"
                                                style={{ textDecoration: "none", padding: "8px 12px", color: "inherit", display: "flex", alignItems: "center" }}
                                            >
                                                <i className="fas fa-download" style={{ marginRight: "10px", width: "16px", textAlign: "center" }}></i> Download
                                            </a>

                                            {AppContext.userRole === "Admin" && (
                                                deletingId === value ? (
                                                    <div className="submissions-dropdown-item" style={{ padding: "8px 12px", display: "flex", alignItems: "center" }}>
                                                        <LoadingSpinnerImage small={true} />
                                                        <span style={{ marginLeft: "10px" }}>Deleting...</span>
                                                    </div>
                                                ) : (
                                                    <span
                                                        onClick={() => {
                                                            setConfirmDeleteId(value);
                                                            setOpenDropdownId(null);
                                                        }}
                                                        className="submissions-dropdown-item"
                                                        style={{ cursor: "pointer", padding: "8px 12px", color: "inherit", display: "flex", alignItems: "center" }}
                                                    >
                                                        <i className="fas fa-times-circle" style={{ marginRight: "10px", width: "16px", textAlign: "center" }}></i> Delete
                                                    </span>
                                                )
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                    },
                ]}
                fetchUrl="/umbraco/api/RIMSRegistrations/Documents/"
                enableDelete={AppContext.userRole == "Admin" ? true : false}
                enableExport={false}
                queryParams={{
                    entityId: AppContext.currentItem.Id,
                    docType: "operators"
                }}
                exportFileName={`${AppContext.currentItem.Name}-documents-export.xlsx`}
                rowTitleKey="ProductName"
                rowIdKey="CertificateFileId"
                searchPlaceholder="Search Documents"
                LoadingComponent={LoadingSpinnerImage}
                customButtons={customButtons}
                refresh={refresh}
                showTotalCount={true}
                totalCountUrl="/umbraco/api/RIMSRegistrations/DocumentsCount/"

            />

            {/* CONFIRMATION MODAL */}
            {confirmDeleteId && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            width: "320px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
                        }}
                    >
                        <h3 style={{ marginTop: 0 }}>Confirm Delete</h3>

                        <p style={{ marginBottom: "20px" }}>
                            Are you sure you want to delete this document?
                        </p>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button
                                onClick={() => setConfirmDeleteId(null)}
                                style={{
                                    padding: "6px 12px",
                                    border: "1px solid #ccc",
                                    background: "#fff",
                                    cursor: "pointer",
                                    borderRadius: "4px"
                                }}
                                disabled={deletingId === confirmDeleteId}
                            >
                                Cancel
                            </button>

                            <button
                                onClick={() => removeDocument(confirmDeleteId)}
                                style={{
                                    padding: "6px 12px",
                                    border: "none",
                                    background: "#d11a2a",
                                    color: "#fff",
                                    cursor: "pointer",
                                    borderRadius: "4px"
                                }}
                                disabled={deletingId === confirmDeleteId}
                            >
                                {deletingId === confirmDeleteId ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};







const OperatorsStandardsTable = ({ AppContext }) => {

    const [standards, setStandards] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let dataUrl = AppContext?.complianceStandardsUrl + AppContext.currentItem.Id;


    useEffect(() => {

        setIsLoading(true);

        let requestOptions = {
            method: "GET",
        };

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setStandards(result);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
            });

    }, []);


    const getComplianceStatus = (statusId) => {
        let name = "";
        let textColor = "";
        let bgColor = "";

        switch (statusId) {
            case 0:
                name = "No status";
                bgColor = "#f0f0f0";
                textColor = "black";
                break;
            case 1:
                name = "In compliance";
                bgColor = "#48ca94";
                textColor = "white";
                break;
            case 2:
                name = "In compliance – action required";
                bgColor = "#f7b204";
                textColor = "white";
                break;
            case 3:
                name = "Partly in compliance";
                bgColor = "#f7b204";
                textColor = "white";
                break;
            case 4:
                name = "Not in compliance";
                bgColor = "#d1153a";
                textColor = "white";
                break;
            case 5:
                name = "New – in progress";
                bgColor = "#3398dc";
                textColor = "white";
                break;
            case 6:
                name = "Archived";
                bgColor = "#888";
                textColor = "white";
                break;
            default:
                break;
        }

        return (
            <div
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "200px",
                    textAlign: "center",
                }}
            >
                {name}
            </div>
        );
    };

    const getOriginType = (origin, type) => {
        let name = "";
        let title = "";
        const textColor = "#757575";
        const bgColor = "#e1e1e1";

        switch (origin) {
            case "product-family":
                name = "Family";
                title = `This ${type} is linked to the family of this product`;
                break;
            case "product-skus":
                name = "Product";
                title = `This ${type} is linked to this product`;
                break;
            default:
                break;
        }

        return (
            <div
                title={title}
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "100px",
                    textAlign: "center",
                    cursor: "help",
                }}
            >
                {name}
            </div>
        );
    };

    return (
        <div id="standards">
            <div className="product-view-block" style={{ textAlign: "center" }}>
                <h3>Standards</h3>
                <br />

                {isLoading ? <div><LoadingSpinnerImage /></div> : <>

                    {standards.length === 0 ? (
                        <span>There are no standards associated to this product</span>
                    ) : (
                        <table
                            border="1"
                            className="dataTable"
                            style={{ width: "100%", marginBottom: 0 }}
                        >
                            <thead>
                                <tr style={{ backgroundColor: "#f3f3f3" }}>
                                    <th>REFERENCE</th>
                                    <th>DESCRIPTION</th>
                                    <th>COMPLIANCE STATUS</th>
                                    <th>LINKED TO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {standards.map((standard) => (
                                    <tr key={standard.Id}>
                                        <td style={{ width: "20%", padding: "5px", textAlign: "left" }}>
                                            <a href={`${AppContext.productStandardsListItemUrl}?viewItemId=${standard.Id}`}>
                                                {standard.Name}
                                            </a>
                                        </td>
                                        <td style={{ width: "60%", padding: "5px", textAlign: "left" }}>
                                            {standard.Description}
                                        </td>
                                        <td style={{ width: "10%", padding: "5px", textAlign: "left" }}>
                                            {getComplianceStatus(standard.Status)}
                                        </td>
                                        <td style={{ width: "10%", padding: "5px", textAlign: "left" }}>
                                            {getOriginType(standard.EntityType, "standard")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                </>}

            </div>
        </div>
    );
};





const OperatorsRegulatoryDocumentsTable = ({ AppContext }) => {

    const [regdocs, setRegdocs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let dataUrl = AppContext?.complianceRegdocsUrl + AppContext.currentItem.Id;


    useEffect(() => {

        setIsLoading(true);

        let requestOptions = {
            method: "GET",
        };

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setRegdocs(result);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
            });

    }, []);





    const getComplianceStatus = (statusId) => {
        let name = "";
        let textColor = "";
        let bgColor = "";

        switch (statusId) {
            case 0:
                name = "No status";
                bgColor = "#f0f0f0";
                textColor = "black";
                break;
            case 1:
                name = "In compliance";
                bgColor = "#48ca94";
                textColor = "white";
                break;
            case 2:
                name = "In compliance – action required";
                bgColor = "#f7b204";
                textColor = "white";
                break;
            case 3:
                name = "Partly in compliance";
                bgColor = "#f7b204";
                textColor = "white";
                break;
            case 4:
                name = "Not in compliance";
                bgColor = "#d1153a";
                textColor = "white";
                break;
            case 5:
                name = "New – in progress";
                bgColor = "#3398dc";
                textColor = "white";
                break;
            case 6:
                name = "Archived";
                bgColor = "#888";
                textColor = "white";
                break;
            default:
                break;
        }

        return (
            <div
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "200px",
                    textAlign: "center",
                }}
            >
                {name}
            </div>
        );
    };

    const getOriginType = (origin, type) => {
        let name = "";
        let title = "";
        const textColor = "#757575";
        const bgColor = "#e1e1e1";

        switch (origin) {
            case "product-family":
                name = "Family";
                title = `This ${type} is linked to the family of this product`;
                break;
            case "product-skus":
                name = "Product";
                title = `This ${type} is linked to this product`;
                break;
            default:
                break;
        }

        return (
            <div
                title={title}
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "100px",
                    textAlign: "center",
                    cursor: "help",
                }}
            >
                {name}
            </div>
        );
    };

    return (
        <div id="regdocs">
            <div className="product-view-block" style={{ textAlign: "center" }}>
                <h3>Regulations</h3>
                <br />

                {isLoading ? <div><LoadingSpinnerImage /></div> : <>

                    {regdocs.length === 0 ? (
                        <span>
                            There are no regulations associated to this operator
                        </span>
                    ) : (
                        <table
                            border="1"
                            className="dataTable"
                            style={{ width: "100%", marginBottom: 0 }}
                        >
                            <thead>
                                <tr style={{ backgroundColor: "#f3f3f3" }}>
                                    <th>TITLE</th>
                                    <th>COUNTRY</th>
                                    <th>REGULATORY AREA</th>
                                    <th>COMPLIANCE STATUS</th>
                                    <th>LINKED TO</th>
                                </tr>
                            </thead>
                            <tbody>
                                {regdocs.map((regdoc) => (
                                    <tr key={regdoc.Id} style={{ height: "21px" }}>
                                        <td
                                            style={{
                                                width: "50%",
                                                padding: "5px",
                                                textAlign: "left",
                                            }}
                                        >
                                            <a
                                                href={`${AppContext.productRegulatoryDocumentsListItemUrl}?viewItemId=${regdoc.Id}`}
                                            >
                                                {regdoc.Name}
                                            </a>
                                        </td>
                                        <td style={{ width: "15%", padding: "5px" }}>
                                            {regdoc.Country}
                                        </td>
                                        <td style={{ width: "15%", padding: "5px" }}>
                                            {regdoc.RegulatoryArea}
                                        </td>
                                        <td style={{ width: "10%", padding: "5px" }}>
                                            {getComplianceStatus(regdoc.Status)}
                                        </td>
                                        <td style={{ width: "10%", padding: "5px", textAlign: "left" }}>
                                            {getOriginType(
                                                regdoc.EntityType,
                                                "regulatory document"
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                </>}
            </div>
        </div>
    );
};






const OperatorsComplianceTables = ({ AppContext, operatorId }) => {
    const [standards, setStandards] = useState([]);
    const [regdocs, setRegdocs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const dataUrl = `/umbraco/api/RIMSRegistrations/Compliance/?operatorId=${operatorId}`;

    useEffect(() => {
        setIsLoading(true);

        fetch(dataUrl, {
            method: "GET",
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                return response.json();
            })
            .then((result) => {
                setStandards(result?.Standards || []);
                setRegdocs(result?.RegulatoryDocuments || []);
            })
            .catch((error) => {
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [dataUrl]);

    const getComplianceStatus = (statusId) => {
        let name = "";
        let textColor = "";
        let bgColor = "";

        switch (statusId) {
            case 0:
                name = "No status";
                bgColor = "#f0f0f0";
                textColor = "black";
                break;
            case 1:
                name = "In compliance";
                bgColor = "#48ca94";
                textColor = "white";
                break;
            case 2:
                name = "In compliance – action required";
                bgColor = "#f7b204";
                textColor = "white";
                break;
            case 3:
                name = "Partly in compliance";
                bgColor = "#f7b204";
                textColor = "white";
                break;
            case 4:
                name = "Not in compliance";
                bgColor = "#d1153a";
                textColor = "white";
                break;
            case 5:
                name = "New – in progress";
                bgColor = "#3398dc";
                textColor = "white";
                break;
            case 6:
                name = "Archived";
                bgColor = "#888";
                textColor = "white";
                break;
            default:
                break;
        }

        return (
            <div
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "200px",
                    textAlign: "center",
                }}
            >
                {name}
            </div>
        );
    };

    const getOriginType = (origin, type) => {
        let name = "";
        let title = "";

        const textColor = "#757575";
        const bgColor = "#e1e1e1";

        switch (origin) {
            case "product-family":
                name = "Family";
                title = `This ${type} is linked to the family of this product`;
                break;

            case "product-skus":
                name = "Product";
                title = `This ${type} is linked to this product`;
                break;

            default:
                break;
        }

        return (
            <div
                title={title}
                style={{
                    color: textColor,
                    borderRadius: "5px",
                    padding: "5px 8px",
                    backgroundColor: bgColor,
                    width: "100px",
                    textAlign: "center",
                    cursor: "help",
                }}
            >
                {name}
            </div>
        );
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
            }}
        >
            {/* Standards */}
            <div style={{ flex: 1 }}>
                <div
                    id="standards"
                    className="product-view-block"
                    style={{ textAlign: "center", backgroundColor: "white" }}
                >
                    <h3>Standards</h3>
                    <br />

                    {isLoading ? (
                        <div>
                            <LoadingSpinnerImage />
                        </div>
                    ) : (
                        <>
                            {standards.length === 0 ? (
                                <span>
                                    There are no standards associated to this product
                                </span>
                            ) : (
                                <table
                                    border="1"
                                    className="dataTable"
                                    style={{ width: "100%", marginBottom: 0 }}
                                >
                                    <thead>
                                        <tr style={{ backgroundColor: "#f3f3f3" }}>
                                            <th>REFERENCE</th>
                                            <th>DESCRIPTION</th>
                                            <th>COMPLIANCE STATUS</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {standards.map((standard) => (
                                            <tr key={standard.Id}>
                                                <td
                                                    style={{
                                                        width: "20%",
                                                        padding: "5px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    <a
                                                        href={`/your-medboard/compliance-portfolio/standards/?viewItemId=${standard.Id}`}
                                                    >
                                                        {standard.Name}
                                                    </a>
                                                </td>

                                                <td
                                                    style={{
                                                        width: "60%",
                                                        padding: "5px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {standard.Description}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "10%",
                                                        padding: "5px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {getComplianceStatus(
                                                        standard.Status
                                                    )}
                                                </td>

                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* Regulatory Documents */}
            <div style={{ flex: 1 }}>
                <div
                    id="regdocs"
                    className="product-view-block"
                    style={{ textAlign: "center", backgroundColor: "white" }}
                >
                    <h3>Regulations</h3>
                    <br />

                    {isLoading ? (
                        <div>
                            <LoadingSpinnerImage />
                        </div>
                    ) : (
                        <>
                            {regdocs.length === 0 ? (
                                <span>
                                        There are no regulations associated to this operator
                                </span>
                            ) : (
                                <table
                                    border="1"
                                    className="dataTable"
                                    style={{ width: "100%", marginBottom: 0 }}
                                >
                                    <thead>
                                        <tr style={{ backgroundColor: "#f3f3f3" }}>
                                            <th>TITLE</th>
                                            <th>COUNTRY</th>
                                            <th>REGULATORY AREA</th>
                                            <th>COMPLIANCE STATUS</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {regdocs.map((regdoc) => (
                                            <tr
                                                key={regdoc.Id}
                                                style={{ height: "21px" }}
                                            >
                                                <td
                                                    style={{
                                                        width: "50%",
                                                        padding: "5px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    <a
                                                        href={`/your-medboard/compliance-portfolio/regulatory-documents/?viewItemId=${regdoc.Id}`}
                                                    >
                                                        {regdoc.Name}
                                                    </a>
                                                </td>

                                                <td
                                                    style={{
                                                        width: "15%",
                                                        padding: "5px",
                                                    }}
                                                >
                                                    {regdoc.Country}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "15%",
                                                        padding: "5px",
                                                    }}
                                                >
                                                    {regdoc.RegulatoryArea}
                                                </td>

                                                <td
                                                    style={{
                                                        width: "10%",
                                                        padding: "5px",
                                                    }}
                                                >
                                                    {getComplianceStatus(
                                                        regdoc.Status
                                                    )}
                                                </td>

                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};













const CertificateHistory = ({ certificateId, users = [], openTab }) => {

    const [activity, setActivity] = useState([]);
    const [loading, setLoading] = useState(true);

    
    const CertificateAuditActionType = {
        Edited: 0,
        Created: 1,
        UpdatedNotes: 2,
        AddedDocument: 3,
        RemovedDocument: 4,
        DownloadedDocument: 5,
        AddedProduct: 6,
        RemovedProduct: 7,
        AddedActivity: 8,
        DeletedCertificate: 9,
        DeletedEstablishment: 10,
        UpdatedOperatorContacts: 11,
        UpdatedOperatorIdentifiers: 12,
        UpdatedOperatorCertificateSettings: 13,
        UpdatedAlerts: 14,
        UpdateBulkCertificate: 15
    };

    const actionTitles = {
        [CertificateAuditActionType.Edited]: "Edited",
        [CertificateAuditActionType.Created]: "Created",
        [CertificateAuditActionType.UpdatedNotes]: "Updated Notes",
        [CertificateAuditActionType.AddedDocument]: "Added Document",
        [CertificateAuditActionType.RemovedDocument]: "Removed Document",
        [CertificateAuditActionType.DownloadedDocument]: "Downloaded Document",
        [CertificateAuditActionType.AddedProduct]: "Added Product",
        [CertificateAuditActionType.RemovedProduct]: "Removed Product",
        [CertificateAuditActionType.AddedActivity]: "New Comment.",
        [CertificateAuditActionType.DeletedCertificate]: "Deleted Certificate",
        [CertificateAuditActionType.DeletedEstablishment]: "Deleted Operator",
        [CertificateAuditActionType.UpdatedOperatorContacts]: "Updated Contacts",
        [CertificateAuditActionType.UpdatedOperatorIdentifiers]: "Updated Identifiers",
        [CertificateAuditActionType.UpdatedOperatorCertificateSettings]: "Updated Certificate Settings",
        [CertificateAuditActionType.UpdatedAlerts]: "Updated Assign User & Alerts",
        [CertificateAuditActionType.UpdateBulkCertificate]: "Updated Bulk Settings",
    };

    const getDescription = (item) => {
        switch (item.Type) {
            case CertificateAuditActionType.Edited:
                return "Edited this operator's properties";

            case CertificateAuditActionType.Created:
                return "Created this operator";

            case CertificateAuditActionType.UpdatedNotes:
                return "Updated this operator's notes";

            case CertificateAuditActionType.AddedDocument:
                return `Uploaded a new document: ${item.ExtraDetails}`;

            case CertificateAuditActionType.RemovedDocument:
                return `Removed a document: ${item.ExtraDetails}`;

            case CertificateAuditActionType.DownloadedDocument:
                return `Downloaded a document: ${item.ExtraDetails}`;

            case CertificateAuditActionType.AddedProduct:
                return `Added a new product to this operator ${item.ExtraDetails}`;

            case CertificateAuditActionType.RemovedProduct:
                return `Removed a product from this operator ${item.ExtraDetails}`;

            case CertificateAuditActionType.AddedActivity:
                return "Added a comment in activity.";

            case CertificateAuditActionType.DeletedCertificate:
                return "Deleted this operator.";

            case CertificateAuditActionType.DeletedEstablishment:
                return "Deleted this operator.";

            case CertificateAuditActionType.UpdatedOperatorContacts:
                return "Updated this operator's contacts";

            case CertificateAuditActionType.UpdatedOperatorIdentifiers:
                return "Updated this operator's identifiers";

            case CertificateAuditActionType.UpdatedOperatorCertificateSettings:
                return "Updated this operator's certificate settings";

            case CertificateAuditActionType.UpdatedAlerts:
                return "Updated this operator's assigned user and alerts";

            case CertificateAuditActionType.UpdateBulkCertificate:
                return "Updated this operator's bulk settings";

            default:
                return item.Type;
        }
    };

    const formatDate = (date) => {
        if (!date) return "";

        return new Date(date).toLocaleString();
    };


    useEffect(() => {
        if (!certificateId) return;

        const loadHistory = async () => {
            try {
                setLoading(true);

                const response = await fetch(
                    `/umbraco/api/RIMSRegistrations/History/?certificateId=${certificateId}`
                );

                if (!response.ok) {
                    throw new Error("Failed to load history");
                }

                const data = await response.json();

                setActivity(data || []);
            } catch (error) {
                console.error("Error loading operator history:", error);
            } finally {
                setLoading(false);
            }
        };

        loadHistory();
    }, [certificateId]);

    const orderedActivity = useMemo(() => {
        return [...activity].sort(
            (a, b) => new Date(b.CreatedAt) - new Date(a.CreatedAt)
        );
    }, [activity]);

    const getUser = (authorId) => {
        return users.find((x) => x.id === authorId || x.Id === authorId);
    };

    return (
        <div>
            {loading && <div><LoadingSpinnerImage /></div>}

            {!loading && !orderedActivity.length && (
                <p>No history exists yet for this operator.</p>
            )}

            {!loading &&
                orderedActivity.map((item) => {
                    const user = getUser(item.Author);

                    return (
                        <section
                            className="g-pos-rel g-left-25--before"
                            key={item.AuditEntryId}
                        >
                            <div className="g-orientation-left g-pos-rel g-ml-25--md g-pl-20">
                                <div className="g-hidden-sm-down u-timeline-v2__icon g-top-35">
                                    <i className="d-block g-width-16 g-height-16 g-bg-white g-brd-around g-brd-2 g-brd-secondary rounded-circle"></i>
                                </div>

                                <div className="media">
                                    <div className="d-flex align-self-center g-mr-15">
                                        <FieldTypes.FieldType_User value={item.Author} users={users} />
                                    </div>

                                    <div className="media-body align-self-center">
                                        <h3 className="g-font-weight-300 g-font-size-16 g-mb-3">
                                            {user?.Name || "Unknown User"}
                                        </h3>

                                        <em className="g-font-style-normal g-color-secondary">
                                            {actionTitles[item.Type] || item.Type}
                                        </em>
                                    </div>

                                    <div className="d-flex align-self-center g-mr-15">
                                        {formatDate(item.CreatedAt)}
                                    </div>
                                </div>

                                <p className="g-font-weight-300 g-font-size-default">
                                    {getDescription(item)}
                                </p>
                            </div>

                            <hr className="d-flex g-brd-gray-light-v4 g-ml-35--md g-my-20 g-my-30--md" />
                        </section>
                    );
                })}
        </div>
    );
};




const UploadPdfPopup = ({ certificateId, onClose, onSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isDragging, setIsDragging] = useState(false);

    const fileInputRef = useRef(null);

    // --- Drag and Drop Handlers ---
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setSelectedFile(e.dataTransfer.files[0]);
            setError("");
            e.dataTransfer.clearData();
        }
    };
    // ------------------------------

    const handleUpload = async () => {
        if (!selectedFile) {
            setError("Please select a PDF file.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            const response = await fetch(
                `/umbraco/api/RIMSRegistrations/Documents?certificateId=${certificateId}`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            if (!response.ok) {
                throw new Error("Upload failed");
            }

            setSelectedFile(null);

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }

            if (onSuccess) onSuccess();
            if (onClose) onClose();
        } catch (err) {
            console.error(err);
            setError("Failed to upload file.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            id="add-pdf-popup"
            style={{
                position: "fixed",
                left: 0,
                right: 0,
                top: "120px",
                width: "90%",
                maxWidth: "400px",
                margin: "0 auto",
                zIndex: 1000,
                padding: "24px",
                border: "1px solid rgb(224, 224, 224)",
                borderRadius: "12px",
                backgroundColor: "rgb(255, 255, 255)",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px",
                fontFamily: "sans-serif"
            }}
        >
            {/* Header Section */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "rgb(55, 65, 81)" }}>
                    Upload File
                </h3>
                <button
                    onClick={onClose}
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "18px",
                        color: "rgb(156, 163, 175)",
                        padding: "4px",
                        transition: "color 0.2s"
                    }}
                    onMouseEnter={(e) => e.target.style.color = "rgb(75, 85, 99)"}
                    onMouseLeave={(e) => e.target.style.color = "rgb(156, 163, 175)"}
                >
                    ✕
                </button>
            </div>

            {/* Drag & Drop Styled Label */}
            <label
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "30px 20px",
                    border: "2px dashed",
                    borderColor: isDragging ? "#3498db" : "rgb(209, 213, 219)", // highlight border on drag
                    borderRadius: "8px",
                    cursor: "pointer",
                    backgroundColor: isDragging ? "rgb(243, 244, 246)" : "rgb(249, 250, 251)", // highlight bg on drag
                    transition: "0.2s"
                }}
                onMouseEnter={(e) => { if (!isDragging) e.currentTarget.style.backgroundColor = "rgb(243, 244, 246)" }}
                onMouseLeave={(e) => { if (!isDragging) e.currentTarget.style.backgroundColor = "rgb(249, 250, 251)" }}
            >
                <i className="fas fa-upload" style={{ fontSize: "24px", color: isDragging ? "#3498db" : "rgb(156, 163, 175)", marginBottom: "8px" }}></i>
                <span style={{ textAlign: "center", fontSize: "14px", color: "rgb(75, 85, 99)" }}>
                    {selectedFile ? selectedFile.name : "Click to select a file or drag and drop"}
                </span>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="application/pdf, 
                    application/msword, 
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document, 
                    application/vnd.ms-excel, 
                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, 
                    application/vnd.ms-powerpoint,
                    application/vnd.openxmlformats-officedocument.presentationml.presentation,
                    image/*,
                    text/plain,
                    text/csv,
                    .ris"
                    onChange={(e) => {
                        setSelectedFile(e.target.files ? e.target.files[0] : null);
                        setError(""); // Reset error on manual file select
                    }}
                    style={{ display: "none" }}
                />
            </label>

            {/* Action Button Section */}
            <div style={{ textAlign: "center" }}>
                <button
                    disabled={loading || !selectedFile}
                    onClick={handleUpload}
                    className="btn u-btn-blue g-font-size-13 g-pl-12 g-pr-12 g-pt-8 g-pb-8"
                    style={{
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        cursor: (loading || !selectedFile) ? "not-allowed" : "pointer",
                        opacity: (loading || !selectedFile) ? 0.6 : 1,
                        borderWidth: "medium",
                        borderStyle: "none",
                        borderColor: "currentcolor",
                        borderImage: "initial",
                        width: "100%",
                        transition: "background 0.2s",
                        padding: "10px 16px",
                        fontSize: "14px",
                        fontWeight: "500"
                    }}
                >
                    <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-arrow-up"}></i>
                    {loading ? "Uploading..." : "Submit"}
                </button>
            </div>

            {/* Error Message */}
            {error && (
                <div style={{ color: "#dc2626", fontSize: "13px", marginTop: "-10px", textAlign: "center" }}>
                    {error}
                </div>
            )}
        </div>
    );
};






const CommentsPanel = ({ AppContext, operatorId, user }) => {
    const [comments, setComments] = useState([]);
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);
    const [posting, setPosting] = useState(false);

    useEffect(() => {
        if (!operatorId) return;
        fetchComments();
    }, [operatorId]);

    async function fetchComments() {
        setLoading(true);
        try {
            const res = await fetch(
                `/umbraco/api/RIMSRegistrations/Comments?operatorId=${operatorId}`
            );

            const data = await res.json();

            // filter empty comments (you have these in API)
            //const cleaned = (data || []).filter((c) => c.Comment?.trim());

            setComments(data);
        } catch (err) {
            console.error("Failed to load comments", err);
        } finally {
            setLoading(false);
        }
    }

    async function handleAddComment() {
        if (!comment.trim()) return;

        setPosting(true);
        try {
            await fetch(
                `/umbraco/api/RIMSRegistrations/Comments?operatorId=${operatorId}&comment=${encodeURIComponent(
                    comment
                )}`,
                { method: "POST" }
            );

            setComment("");
            await fetchComments();
        } catch (err) {
            console.error("Failed to post comment", err);
        } finally {
            setPosting(false);
        }
    }

    function formatDate(iso) {
        if (!iso) return "";
        return new Date(iso).toLocaleString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        });
    }


    let userId = AppContext.users?.find(user => user.IsItMe)?.Id;

    return (
        <div style={{ marginBottom: 20 }}>
            {/* ADD COMMENT */}
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div>
                    <FieldTypes.FieldType_User value={userId} users={AppContext.users} />
                </div>

                <div style={{ flex: 1, marginLeft: 10 }}>
                    <textarea
                        style={{ width: "100%" }}
                        className="addCommentTextBox form-field-text"
                        placeholder="Add a comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />

                    <div style={{ marginTop: 10 }}>
                        <button
                            className="action-button save-button"
                            onClick={handleAddComment}
                            disabled={posting}
                        >
                            {posting ? "Saving..." : "Save comment"}
                        </button>
                    </div>
                </div>
            </div>

            <div style={{ marginTop: 20 }} />

            {/* LIST */}
            <div style={{ maxHeight: "100vh", overflow: "auto", paddingRight: 10 }}>
                {loading ? (
                    <div><LoadingSpinnerImage /></div>
                ) : (
                    comments.map((c) => (
                        <div key={c.NoteId}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <div>
                                    <FieldTypes.FieldType_User value={c.Author} users={AppContext.users} />
                                </div>

                                <div style={{ flex: 1, marginLeft: 10 }}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div style={{ fontWeight: "bold" }}>
                                            {AppContext.users?.find(user => user.Id == c.Author)?.Name}
                                        </div>

                                        <div style={{ color: "#a8a8a8" }}>
                                            {formatDate(c.CreatedAt)}
                                        </div>
                                    </div>

                                    <div>{c.Comment}</div>
                                </div>
                            </div>

                            <div
                                style={{
                                    marginTop: 20,
                                    borderTop: "1px solid #f3f3f3",
                                    marginBottom: 20,
                                }}
                            />
                        </div>
                    ))
                )}

                {!loading && comments.length === 0 && (
                    <div>No more comments</div>
                )}
            </div>
        </div>
    );
};









export default ItemDetailsPane;